module.exports = __webpack_public_path__ + "DikshaSubba-2bdb1685.webp";